/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, Tc) {
	'use strict';

	/**
	 * MultiDropdown
	 *
	 * @author Michael Keller
	 * @namespace Tc.Module
	 * @class MultiDropdown
	 * @extends Tc.Module
	 */
	Tc.Module.MultiDropdown = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.$select = $ctx.find('select');
			mod.isMulti = mod.$select.is('[multiple]');
			mod.name = mod.$select.attr('name');
			mod.label = $ctx.find('label').text();
			// only for desktop - when multiselect is restyled
			if (mod.$select.is('.multiselect')) {
				$ctx.find('label').hide();
			}

			// on change read value and broadcast it to all listening modules
			mod.$select.on('change', function() {
				mod.values = mod.readValue();
				mod.broadcastValue();
				mod.checkIfEmpty();

				//Used in PEX Form Archive. On mobile view, title(label) of the dropdown should always stay the same, selected values need to be visible only in modMultiDropdownFilter
				if (mod.$ctx.hasClass('static-title')){
					mod.$ctx.find('.ui-btn > span:first').text(mod.label);
				}

				mod.$ctx.trigger('multidropdown-changed', mod.values, mod.getValue());
			});

			if (!mod.isMulti) {
				mod.$select.addClass('singleselect');
				var showAllText = $ctx.data('show-all');
				if(showAllText) {
					mod.$select.append('<option class="novalue" value="">' + showAllText + '</option>');
				}

				if (mod.$select.find('option.preselected').length === 0) {
					mod.$select.find('option.novalue').prop('selected', true);
				}

				// for single selects - ie8 does not get the clicks on the inputs as custom-inputs does not redirect the click
				$(document).on('click', '.ui-multiselect-single li > label', function(e) {
					if (!$(e.target).is('input')) {
						$(this).find('input[type="radio"]').click();

					}
				});
			}

			mod.values = mod.readValue();

			// only for desktop
			if (mod.$select.is('.multiselect')) {
				mod.$select.multiselect({
					selectedText: mod.label,
					noneSelectedText: mod.label,
					header: false,
					minWidth: 50,
					height: 275,
					multiple: mod.isMulti,
					open: function(){
						var $this = $(this),
							$list = $this.multiselect('widget'),
							listHeight = $this.multiselect('option','height');

						$list.find('ul').css('max-height', listHeight + 'px');

						if ($list.height() < listHeight){
							$list.find('ul').css('overflow-y','auto');
						}
					}
				});
			}
			// only for mobile
			else {
				mod.$ctx.find('.ui-btn > span:first').text(mod.label);
				mod.fixMultiSelects();
			}

			mod.initAPI();

			callback();
		},

		after: function() {
			var mod = this;
			mod.broadcastValue();
		},

		initAPI: function() {
			var mod = this;
			mod.$ctx[0].multidropdown = {
				isMulti: function() {
					return mod.isMulti;
				},
				getModule: function() {
					return mod;
				},
				readValue: function() {
					return mod.value;
				},
				getValue: mod.getValue.bind(mod),
				setValue: mod.setValue.bind(mod),
				addValue: mod.addValue.bind(mod),
				allValues: mod.allValues.bind(mod),
				removeValue: mod.removeValue.bind(mod),
				valueLabel: mod.valueLabel.bind(mod)
			};
			mod.$ctx.data('multidropdown-api', mod.$ctx[0].multidropdown);
		},

		// boardcast value together with name and label
		broadcastValue: function() {
			var mod = this;
			mod.fire('updateValue', { name : mod.name, label : mod.label, valueObj : mod.values });
		},

		// reads value and returns it as array
		readValue: function() {
			var mod = this,
				rawValues = mod.$select.val(),
				valueObj = null,
				i = 0;

			if (rawValues === null) {
				rawValues = [];
			}
			valueObj = { labels: [], values: rawValues };

			for (i = 0; valueObj && valueObj.values && i < valueObj.values.length; i+=1) {
				valueObj.labels[i] = mod.valueLabel(valueObj.values[i]);
			}

			return valueObj;
		},

		valueLabel: function(value) {
			return this.$select.find('option[value="'+value+'"]').text();
		},

		// remove filter when filter was removed in other module
		onRemoveFilter: function(data) {
			var mod = this;

			if (!mod.$select.is('[name="'+data.name+'"]')) {
				return;
			}

			mod.removeValue(data.value);
		},

		onSetFilters: function(data) {
			var mod = this,
				i = 0;
			if (data.newValues) {
				data = data.newValues;
				if (data && data.length > 0) {
					for (i = 0; i < data.length; i++) {
						if (data[i].name === mod.name) {
							mod.$select.filter('[name="'+data[i].name+'"]').find('option[value="'+data[i].value+'"]').attr('selected', 'selected');
						}
					}
				}
				// MultiSelect module only on desktop
				if (mod.$select.is('.multiselect')) {
					// Inform the multiselect of the change
					mod.$select.multiselect('refresh');
				}
				mod.$select.change();
			}
		},

		getValue: function() {
			var mod = this;
			var value = mod.values.values;
			if(mod.isMulti) {
				// Make a copy to not allow internal state to be changed from the outside
				return  $.isArray(value) ? value.slice() : [value];
			} else {
				return $.isArray(value) ? value[0] : value;
			}
		},

		setValue: function(val) {
			var mod = this;
			if(mod.isMulti) {
				if(!$.isArray(val)) {
					val = val === null ? [] : [val];
				}
			} else {
				if($.isArray(val)) {
					val = val[0];
				}
			}
			if(!mod.isMulti && val === null) {
				// Special-case no-value case in multiselect
				mod.$select.find('option').prop('selected', false).filter('.novalue').prop('selected', true);
			} else if(mod.isMulti && !val.length) {
				// fix for chrome on android issue => https://code.google.com/p/chromium/issues/detail?id=331737
				mod.$select.prepend('<option class="toremove" />');
				mod.$select.val(val);
				mod.$select.find('.toremove').remove();
			} else {
				// Usual case
				mod.$select.val(val);
			}
			// MultiSelect module only on desktop
			if (mod.$select.is('.multiselect')) {
				// Inform the multiselect of the change
				mod.$select.multiselect('refresh');
			}
			// Trigger the change handler (will update mod.values)
			mod.$select.change();
		},

		addValue: function(val) {
			var mod = this;
			if(mod.isMulti) {
				var currentValue = mod.getValue();
				if(currentValue.indexOf(val) >-1) {
					// Already set
					return;
				}
				currentValue.push(val);
				val = currentValue;
			}
			mod.setValue(val);
		},

		allValues: function() {
			var mod = this;
			return mod.$select.find('option').map(function() {
				return this.value;
			}).get();
		},

		removeValue: function(val) {
			var mod = this;
			var currentValue = mod.getValue();
			var newValue = null;
			if(mod.isMulti) {
				var index;
				if((index = currentValue.indexOf(val)) === -1) {
					// Alredy not set
					return;
				}

				// Remove the value
				currentValue.splice(index, 1);
				newValue = currentValue;
			} else {
				if(currentValue !== val) {
					return;
				}
			}

			mod.setValue(newValue);
		},

		onClearAll: function() {
			var mod = this;

			if (mod.checkIfEmpty()) {
				return;
			}
			if (mod.isMulti) {
				mod.setValue([]);
			} else {
				mod.setValue(null);
			}
		},

		checkIfEmpty: function() {
			var mod = this;
			if (mod.$select.find('option:selected:not(.novalue)').length === 0) {
				if (!mod.$select.is('.multiselect')) {
					mod.$ctx.find('.ui-btn > span').text(mod.label);
				}
				return true;
			}
			return false;
		},

		// hack for iPhone 7.0.3 multiselects bug
		// https://discussions.apple.com/message/24694954#24694954
		fixMultiSelects: function () {
			var mod = this;
			if (navigator.userAgent.match(/iphone os 7.0/i)) {
				mod.$ctx.find('select[multiple]').each(function () {
					var select = $(this).on({
						focusout: function () {
							var values = select.val() || [];
							setTimeout(function () {
								select.val(values.length ? values : ['']).change();
							}, 1000);
						}
					});
					var firstOption = '<option value="" disabled="disabled"';
					firstOption += (select.val() || []).length ? '' : ' selected="selected"';
					firstOption += '>' + mod.label + '';
					firstOption += '</option>';
					select.prepend(firstOption);
				});
			}
		}

	});
}(window.Tc.$, window.Tc));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.MultiDropdown.js
// module id = 154
// module chunks = 0